import { ImageRibbonVerified, ImageRibbonValidated, ImageRibbonCertified } from 'src/components/Svg/Images';
import { type ICertificateType } from '@/widgets/Certificate';
import { cn } from 'src/lib/utils';

type Props = {
  type: ICertificateType;
  className?: string;
  badgeClassName?: string;
};

const iconTypeMap = {
  verified: ImageRibbonVerified,
  validated: ImageRibbonValidated,
  certified: ImageRibbonCertified,
};

const CertificatePlaceholder = ({ type, className, badgeClassName }: Props) => {
  const RibbonIcon = iconTypeMap[type];

  return (
    <div
      className={cn(
        'w-25 h-30 bg-white rounded-sm border border-border shadow-sm grid grid-cols-2 gap-0.5 overflow-hidden',
        className,
      )}
    >
      <div className="flex flex-col gap-[10px] self-center pl-1.5">
        <span className="h-0.5 bg-input rounded" />
        <span className="h-0.5 bg-input rounded" />
        <span className="h-0.5 bg-input rounded" />
      </div>
      <div className="pr-[3px]">
        <RibbonIcon className={cn('relative w-full! h-[85px]! -top-px', badgeClassName)} />
      </div>
    </div>
  );
};

export default CertificatePlaceholder;
